<template>
	<tr>
		<template v-for="(column, i) in columns">
			<EditableCell
				v-if="isEditable(column)"
				:column="column"
				:item="item"
				:key="column.id"
				:itemValue="value(column)"
				@change-value="changeValue($event, column)"
				:ref="`cell-${i}`"
			/>
			<td class="px-1" v-else :key="column.id" :ref="`cell-${i}`">
				<p class="grow" v-text="cellValue(column)"></p>
			</td>
		</template>
	</tr>
</template>

<script>
import moment from "moment/min/moment.min.js"
import _ from "lodash"
import EditableCell from "./LedgerEditableCell.vue"
import ledgerHelper from "../../../helper/ledgerHelper.js"

export default {
	components: {
		EditableCell,
	},
	props: {
		columns: Array,
		item: Object,
		authorityType: String,
	},
	data() {
		return {
			formula: {
				addition: "+",
				subtraction: "-",
				multiplication: "*",
				division: "/",
			},
		}
	},
	methods: {
		changeValue(newValue, column) {
			let item = _.cloneDeep(this.item)
			if (column.association_array) {
				const associatedModels = column.association_array.split(",")
				if (column.meta_tag_id) {
					let meta = null
					let index = null
					meta = _.get(item, [...associatedModels, column.base_model]).meta_values.find(
						(c) => c.meta_tag_id == column.meta_tag_id
					)
					index = _.get(item, [...associatedModels, column.base_model]).meta_values.indexOf(meta)
					if (index != -1) {
						_.set(
							item,
							[...associatedModels, column.base_model, "meta_values", index, "value"],
							newValue.value
						)
					} else {
						const metaValues = _.get(item, [...associatedModels, column.base_model, "meta_values"])
						metaValues.push(newValue)
						_.set(item, [...associatedModels, column.base_model, "meta_values"], metaValues)
					}
				} else {
					_.set(item, [...associatedModels, column.base_model, column.column_name], newValue)
				}
			} else if (column.meta_tag_id) {
				let meta = null
				let index = null
				if (column.base_model) {
					meta = item[column.base_model].meta_values.find(
						(c) => c.meta_tag_id == column.meta_tag_id
					)
					index = item[column.base_model].meta_values.indexOf(meta)
					if (index != -1) {
						item[column.base_model].meta_values[index].value = newValue.value
					} else {
						item[column.base_model].meta_values.push(newValue)
					}
				} else {
					meta = item.meta_values.find((c) => c.meta_tag_id == column.meta_tag_id)
					index = item.meta_values.indexOf(meta)
					if (index != -1) {
						item.meta_values[index].value = newValue.value
					} else {
						item.meta_values.push(newValue)
					}
				}
			} else {
				if (column.base_model) {
					item[column.base_model][column.column_name] = newValue
				} else {
					item[column.column_name] = newValue
				}
			}
			this.$emit("change-value", item)
		},
		baseModelPresent(column) {
			if (column.association_array) {
				const associatedModels = column.association_array.split(",")
				let modelPresent = true
				let lastModel = _.cloneDeep(this.item)
				associatedModels.forEach((model) => {
					lastModel = lastModel[model]
					if (!lastModel) modelPresent = false
				})
				lastModel = lastModel[column.base_model]
				if (!lastModel) modelPresent = false
				return modelPresent
			} else {
				return this.item[column.base_model] != null
			}
		},
		isEditable(column) {
			return (
				column.editable_flag &&
				!column.function_text &&
				this.dataPresent(column) &&
				(this.authorityType == "edit" ||
					column.ledger_column_authorities.find(
						(a) => a.user_id == this.$store.getters["auth/authData"].id
					) != null)
			)
		},
		cellValue(column) {
			let functionText = column.function_text
			if (column.function_text) {
				column.ledger_function_data.forEach((c, i) => {
					let val = this.value(c)
					let variable = `\${${i}}`
					let times = functionText.split(variable).length - 1
					for (let j = 0; j < times; j++) {
						functionText = functionText.replace(variable, val)
					}
				})
				try {
					return Function(functionText)()
				} catch (err) {
					console.log(err)
					return "ERROR"
				}
			} else if (column.special_type == "original") {
				return ledgerHelper[column.special_string]
			} else if (column.prefix_formula && column.prefix_number) {
				return Function(
					"return (" +
						`${column.prefix_number}${this.formula[column.prefix_formula]}${this.value(column)}` +
						");"
				)()
			} else if (column.suffix_formula && column.suffix_number) {
				return Function(
					"return (" +
						`${this.value(column)}${this.formula[column.suffix_formula]}${column.suffix_number}` +
						");"
				)()
			} else {
				if (column.options.length) {
					const option = column.options.find((o) => o.id == this.value(column))
					if (option) return option.name
				}
				return this.formatValue(column)
			}
		},
		formatValue(column) {
			const value = this.value(column)
			if (value == null) return null
			switch (column.column_type) {
				case "string":
				case "text":
				case "integer":
				case "float":
					return value
				case "time":
					return moment(value).format("HH:mm")
				case "date":
					return moment(value).format("YYYY/MM/DD")
				case "datetime":
					return moment(value).format("YYYY/MM/DD HH:mm")
				case "boolean":
					if (value == true) {
						return "○"
					} else if (value == false) {
						return "x"
					}
			}
		},
		value(column) {
			let value = null
			const item = _.cloneDeep(this.item)
			if (column.association_array) {
				const associatedModels = column.association_array.split(",")
				let lastModel = item
				associatedModels.forEach((model) => {
					if (!lastModel[model]) return null
					lastModel = lastModel[model]
				})
				lastModel = lastModel[column.base_model]
				if (column.meta_tag_id && column.meta_association_name) {
					let meta = null
					if (lastModel.meta_values == null) return null
					meta = lastModel?.meta_values.find((c) => c.meta_tag_id == column.meta_tag_id)
					if (!meta || !meta.association_data) return null
					return meta.association_data[column.column_name]
				} else if (column.meta_tag_id) {
					let meta = null
					if (lastModel.meta_values == null) return null
					meta = lastModel?.meta_values.find((c) => c.meta_tag_id == column.meta_tag_id)
					if (!meta) return null
					return meta.value
				} else {
					return lastModel?.[column.column_name]
				}
			} else if (column.meta_tag_id && column.meta_association_name) {
				let meta = null
				if (column.base_model) {
					meta = item[column.base_model]?.meta_values.find(
						(c) => c.meta_tag_id == column.meta_tag_id
					)
				} else {
					meta = item.meta_values?.find((c) => c.meta_tag_id == column.meta_tag_id)
				}
				if (!meta || !meta.value) return null
				return meta.value[column.column_name]
			} else if (column.meta_tag_id) {
				let meta = null
				if (column.base_model) {
					meta = item[column.base_model]?.meta_values.find(
						(c) => c.meta_tag_id == column.meta_tag_id
					)
				} else {
					meta = item.meta_values?.find((c) => c.meta_tag_id == column.meta_tag_id)
				}
				if (!meta) return null
				return meta.value
			}
			if (column.base_model) {
				value = item[column.base_model]?.[column.column_name]
			} else {
				value = item[column.column_name]
			}
			return value
		},
		dataPresent(column) {
			if (column.base_model && !this.baseModelPresent(column)) {
				return false
			}
			return true
		},
	},
}
</script>

<style scoped>
p {
	white-space: pre-wrap;
	max-width: 100%;
	max-height: 100px;
	overflow-y: scroll;
}
</style>